import { Box, Card, Checkbox, Typography } from '@mui/material'
import { imageType } from '@/utils/helper'

interface FileItem {
  id: string | number
  key_raw: string
  type: string
  image?: string
  calibrated_image?: string
  imageLoaded?: boolean
  dehazed_image?: string
  latest_image?: string
  calibrate_meta?: {
    x: number
    y: number
    protocol: number
  }
}

interface FileListProps {
  data: FileItem[]
  selected: FileItem[]
  handleAddItem: (id: string | number, type: string) => void
  handleRemoveItem: (id: string | number, type: string) => void
  imageUploading?: boolean
  newImages?: any
}

const FileList: React.FC<FileListProps> = ({
  data,
  selected,
  handleAddItem,
  handleRemoveItem,
  imageUploading,
  newImages,
}) => {
  const filteredData = data?.filter(
    (x) =>
      !newImages?.some((img: any) => img.id === x.id && img.type === x.type),
  )

  const getImageUrl = (x: FileItem) => {
    return (
      x?.dehazed_image ||
      x?.latest_image ||
      x?.calibrated_image ||
      (x.imageLoaded && x.calibrated_image) ||
      x.image ||
      ''
    )
  }

  return (
    <Box
      display="flex"
      flexWrap="wrap"
      gap={'32px 24px'}
      minHeight={'400px'}
      minWidth={'700px'}
    >
      {filteredData?.map((x) => {
        const checked = selected.some(
          (item) => item.id === String(x.id) && item.type === x.type,
        )
        const names = x?.key_raw.split('/')
        const fileName = names.length > 0 ? names[names.length - 1] : ''
        return (
          <Box
            width={180}
            key={x.id}
            sx={{ position: 'relative' }}
            onClick={(e) => e.stopPropagation()}
          >
            <Card
              sx={{
                background: '#292929',
                boxShadow: 'none',
                height: '150px',
                width: '180px',
                position: 'relative',
                backgroundImage: `url(${getImageUrl(x)})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: '180px 150px',
                border:
                  x.type === 'raw' && x.calibrated_image
                    ? '2px solid var(--color-accent-neonblue)'
                    : '',
              }}
            >
                <Box
                  borderRadius="6.25rem"
                   bgcolor={!x.calibrated_image && x?.type === imageType.RAW ? '#FFB975' : 'var(--color-accent-neonblue)'}
                  height="1.5rem"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  px={1.5}
                  position="absolute"
                  top="0.7rem"
                  right={'0.5rem'}
                  color={'black'}
                  fontSize="0.8125rem"
                >
                  {x.type === imageType.PHOTO
                    ? (() => {
                        const ext = x.key_raw?.split('.').pop()?.toUpperCase()
                        return ext || 'Photo'
                      })()
                    : x.type !== imageType.RAW
                      ? 'Optishade'
                      : !x.calibrated_image
                        ? 'Not Calibrated'
                        : x.calibrate_meta?.protocol
                          ? `Calibrated L${x.calibrate_meta.protocol}`
                          : 'Calibrated'}
                </Box>
              <Checkbox
                sx={{
                  background: 'none',
                  position: 'absolute',
                  left: 1,
                  top: 1,
                }}
                checked={checked}
                disabled={Boolean(imageUploading)}
                onChange={(e) => {
                  e.stopPropagation()
                  if (checked) {
                    handleRemoveItem(x.id, x.type)
                  } else {
                    handleAddItem(x.id, x.type)
                  }
                }}
                inputProps={{ 'aria-label': 'secondary checkbox' }}
              />
            </Card>
            <Typography
              sx={{
                marginTop: 1,
                textAlign: 'center',
                fontSize: '14px',
                fontWeight: 400,
                maxWidth: '100%',
                overflowWrap: 'break-word',
                wordBreak: 'break-word',
              }}
            >
              {fileName}
            </Typography>
          </Box>
        )
      })}
    </Box>
  )
}

export default FileList
